import { FieldType } from '@pmp/api';

/**
 * The lists that enumerate real records rather than a set of values somebody chose. The BFF draws
 * the same line: these are the fields it gates behind their entity's VIEW permission
 * (`FieldTypePermissionMapper`), plus regions and BDMs, which it reads live from BRS.
 */
const ENTITY_FIELDS: FieldType[] = [
  FieldType.FIRMS,
  FieldType.PRINCIPALS,
  FieldType.ADVISORS,
  FieldType.MORTGAGE_CLUBS,
  FieldType.PACKAGERS,
  FieldType.PAYMENT_ROUTE_FIRMS,
  FieldType.PRINCIPALS_OHPEN_ID,
  FieldType.PACKAGERS_OHPEN_ID,
  FieldType.PAYMENT_ROUTE_FIRMS_OHPEN_ID,
  FieldType.PROCURATION_FEES,
  FieldType.PROCURATION_FEE_RULES,
  FieldType.EXCLUSIVITY_SETS,
  FieldType.CURRENT_PRODUCTS,
  FieldType.FEES,
  FieldType.BASE_RATES,
  FieldType.ERC_PROFILES,
  FieldType.FEE_PROFILES,
  FieldType.REGIONS,
  FieldType.BDMS,
];

const entityFields = new Set<FieldType>(ENTITY_FIELDS);

export const getFieldsOfKind = (kind: 'fixed' | 'entity'): FieldType[] =>
  Object.values(FieldType).filter(field => field !== FieldType.UNKNOWN && entityFields.has(field) === (kind === 'entity'));
